module.exports = __webpack_public_path__ + "img/twitter-logo.92b1a4ac.svg";